module.exports = __webpack_public_path__ + "img/20190725160828968.a5b0e2ad.png";